import type { Template } from "@/types";

export const SQ_01_H0_V1: Template[] = [
    {
        id: "sq-01-h0v1-01",
        name: "SQ 01 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 910, y: 104, width: 340, height: 510, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-02",
        name: "SQ 02 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 838, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-03",
        name: "SQ 03 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 480, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-04",
        name: "SQ 04 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 534, y: 79, width: 373, height: 560, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-05",
        name: "SQ 05 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 517, y: 59, width: 400, height: 600, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "sq-01-h0v1-06",
        name: "SQ 06 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 968, y: 59, width: 400, height: 600, rotation: 0, imageRotation: 0 }
        ],
    },
    {
        id: "sq-01-h0v1-07",
        name: "SQ 07 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 960, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-08",
        name: "SQ 08 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 720, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-09",
        name: "SQ 09 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 1104, y: 164, width: 260, height: 390, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-10",
        name: "SQ 10 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 880, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-11",
        name: "SQ 11 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_11.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 70, y: 59, width: 400, height: 600, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-12",
        name: "SQ 12 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_12.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 189, y: 104, width: 340, height: 510, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-13",
        name: "SQ 13 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_13.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 120, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-14",
        name: "SQ 14 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_14.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-15",
        name: "SQ 15 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_15.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 239, y: 0, width: 480, height: 717, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-16",
        name: "SQ 16 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_16.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 78, y: 164, width: 260, height: 390, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-17",
        name: "SQ 17 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_17.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 229, y: 164, width: 260, height: 390, rotation: 0, imageRotation: 0 },
        ],
    },
    {
        id: "sq-01-h0v1-18",
        name: "SQ 18 - H0V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-01-h0_v1_18.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 202, y: 123, width: 313, height: 470, rotation: 0, imageRotation: 0 },
        ],
    },


];
